import Product from '~/js/models/product'

export default class FSProduct extends Product {
  constructor(product = {}) {
    super(product)
    const variant = product.variants[0]

    this.sku = product.handle
    this.productImage = product.image ? product.image.src : ''
    this.productType = product.product_type || ''
    this.variantId = variant.id
    this.price = variant.price
    this.comparePrice = variant.compare_at_price
    this.comparePriceMin = this.productType.includes('オーダーカーテン') // 要確認
      ? null
      : Math.min(...product.variants.map((v) => v.compare_at_price))
    this.priceMin = Math.min(...product.variants.map((v) => v.price))
  }
}
